import { loginHref } from "../api";
import { el } from "../lib/dom";

export function renderLogin(): HTMLElement {
  return el("main", { class: "login-wrap" }, [
    el("section", { class: "login-hero grad-hero" }, [
      el("p", { class: "eyebrow" }, ["Bounteous internal"]),
      el("h1", { class: "login-title" }, [
        "Your apps, ",
        el("span", { class: "grad-text" }, ["one front door"]),
      ]),
      el("p", { class: "login-sub" }, [
        "Sign in with your Bounteous account to launch Signal, Token Trail, and more — or request access to the ones you need.",
      ]),
      el("a", { href: loginHref(), class: "btn btn-primary btn-lg" }, ["Sign in with Bounteous"]),
    ]),
  ]);
}
